export const SET_HRMS16X_INDEX_DISP = 'SET_HRMS16X_INDEX_DISP'
export const GET_HRMS16X_INDEX_DISP = 'GET_HRMS16X_INDEX_DISP'
export const SET_HRMS16X_COLUMNS = 'SET_HRMS16X_COLUMNS'
export const GET_HRMS16X_COLUMNS = 'GET_HRMS16X_COLUMNS'
export const SET_HRMS16X_LABELS = 'SET_HRMS16X_LABELS'
export const GET_HRMS16X_LABELS = 'GET_HRMS16X_LABELS'
export const RECEIVED_HRMS16X_COLUMNS_LABELS = 'RECEIVED_HRMS16X_COLUMNS_LABELS'
export const SET_HRMS16X_INDEX = 'SET_HRMS16X_INDEX'
export const GET_HRMS16X_INDEX = 'GET_HRMS16X_INDEX'
export const RECEIVED_HRMS16X_INDEX = 'RECEIVED_HRMS16X_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/hrms16x/mutation-types.js